import React, { Suspense, lazy } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import ProtectedLayout from "./ui/layout/ProtectedLayout";
import ProtectedAdminLayout from "./ui/layout/ProtectedAdminLayout";
import PublicLayout from "./ui/layout/PublicLayout";
import ErrorBoundary from "./ui/molecules/MoleculeErrorBoundary";

const SignInPage = lazy(() => import(/* webpackChunkName: "signin" */ "@pages/signin"));
const SignUpPage = lazy(() => import(/* webpackChunkName: "signup" */ "@pages/signup"));
const NotFoundPage = lazy(() => import(/* webpackChunkName: "notfound" */ "@pages/notFound"));
const InfoPage = lazy(() => import(/* webpackChunkName: "info" */ "@pages/info"));
const HomePage = lazy(() => import(/* webpackChunkName: "home" */ "@pages/home"));
const ProfilePage = lazy(() => import(/* webpackChunkName: "profile" */ "@pages/profile"));
const AdminPage = lazy(() => import(/* webpackChunkName: "admin" */ "@pages/admin"));
const WorkspacePage = lazy(() => import(/* webpackChunkName: "workspace" */ "@pages/workspace"));
const HistoryPage = lazy(() => import(/* webpackChunkName: "history" */ "@pages/history"));
const MarketplacePage = lazy(() => import(/* webpackChunkName: "marketplace" */ "@pages/marketplace"));
const OptimizerPage = lazy(() => import(/* webpackChunkName: "optimizer" */ "@pages/optimizer"));

export const preloadProfile = () => import(/* webpackChunkName: "profile" */ "@pages/profile");
export const preloadAdmin = () => import(/* webpackChunkName: "admin" */ "@pages/admin");

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "signin", element: <SignInPage /> },
      { path: "signup", element: <SignUpPage /> },
      { path: "info", element: <InfoPage /> },
    ],
  },
  {
    path: "/",
    element: <ProtectedLayout />,
    children: [
      { path: "workspace", element: <WorkspacePage /> },
      { path: "history", element: <HistoryPage /> },
      { path: "analytics", element: <HistoryPage /> },
      { path: "marketplace", element: <MarketplacePage /> },
      { path: "optimizer", element: <OptimizerPage /> },
      { path: "profile", element: <ProfilePage /> },
    ],
  },
  {
    path: "/admin",
    element: <ProtectedAdminLayout />,
    children: [{ index: true, element: <AdminPage /> }],
  },
  { path: "*", element: <NotFoundPage /> },
]);

function App() {
  return (
    <ErrorBoundary level="page">
      <Suspense
        fallback={
          <Center h="100vh">
            <Spinner size="lg" />
          </Center>
        }
      >
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
